import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

import PlaceCard from '../PlaceCard';
import {TPlace} from '../../Definitions';

type TPlacesProps = {
    children: React.ReactNode;
    places: TPlace[];
    activePlace: TPlace|null;
    setActivePlace: (place: TPlace|null) => void;
    title?: string;
    className?: string;
};
export default ({children, places, activePlace, setActivePlace, title, className}: TPlacesProps) => {
    const isActivated = (place: TPlace) => activePlace?.place_id === place.place_id || false;
    const onToggle = (place: TPlace) => () =>
        setActivePlace(isActivated(place) ? null : place);

    return (
        <>
            {
                Boolean(title) && (
                    <h3>{title}</h3>
                )
            }
            <div className={classNames(styles.placesContainer, className)}>
                {
                    places
                        .map(place => (
                            <PlaceCard
                                key={place.place_id}
                                place={place}
                                isActive={isActivated(place)}
                                toggle={onToggle(place)}
                            />
                        ))
                }
                {children}
            </div>
            <p>
                Die angezeigten Ergebnisse basieren auf „Google my Business“-Daten. Für die Richtigkeit der Anzeigen wird keine Haftung übernommen.
            </p>
            <p>
                <b>Für Unternehmen:</b><br/>
                Sollten Sie Hilfe bei der Anlage eines „Google My Business“-Eintrages haben, wenden Sie sich bitte an die Wirtschaftsförderung der Stadt Bad Tölz. Sollte Ihr Eintrag nicht korrekt dargestellt werden, überprüfen Sie bitte Ihren Google My Business-Eintrag. Die Stadt Bad Tölz übernimmt keine Haftung für die Darstellung der Unternehmen und die Richtigkeit der angezeigten Daten, verantwortlich für Inhalte und Darstellung der Unternehmenseinträge ist das jeweilige Unternehmen selbst.
            </p>
        </>
    );
}
